module.exports = __webpack_public_path__ + "img/logo_jjy.f9b01197.png";